export class IdCache {
    id: number;
    lastAction: Date;
}
